import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import { NotificationTemplateDetailModel } from "@models/notificationTemplate"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"

class SystemConfigurationService {
  // EMAIL SERVER
  public async getListEmailSenderProfile(params: any): Promise<any> {
    const res = await http.get(
      "api/services/app/SystemConfiguration/GetListEmailSenderProfile",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }
  public async getEmailSenderProfile(id): Promise<any> {
    const res = await http.get(
      "api/services/app/SystemConfiguration/GetEmailSenderProfile",
      {
        params: { id },
      }
    )
    const { result } = res.data
    return result
  }
  public async createOrUpdateEmailSenderProfile(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/SystemConfiguration/CreateOrUpdateEmailSenderProfile",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async verifySendMailSmtp(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/SystemConfiguration/VerifySendMailSmtp",
      body
    )
    notifySuccess(LNotification("SUCCESS"), LNotification("SEND_SUCCESSFULLY"))
    return res.data.result
  }
  // SMS provider
  public async getListSmsSenderProfile(params: any): Promise<any> {
    const res = await http.get(
      "api/services/app/SystemConfiguration/GetListSmsSenderProfile",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }
  public async getSmsSenderProfile(id): Promise<any> {
    const res = await http.get(
      "api/services/app/SystemConfiguration/GetSmsSenderProfile",
      {
        params: { id },
      }
    )
    const { result } = res.data
    return result
  }
  public async createOrUpdateSmsSenderProfile(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/SystemConfiguration/CreateOrUpdateSmsSenderProfile",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  // EMAIL SMS
  public async getAllTemplatesMap(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/TemplateNotify/GetAllTemplatesMap",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }
  public async getGetTemplate(id): Promise<any> {
    const res = await http.get("api/services/app/TemplateNotify/GetTemplate", {
      params: { id },
    })
    const { result } = res.data
    return NotificationTemplateDetailModel.assign(result)
  }

  public async getListPrintingTemplate(params?: any): Promise<any> {
    const res = await http.get(
      "api/services/app/TemplateNotify/GetListPrintingTemplate",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }

  public async createOrUpdateNotificationTemplate(body: any): Promise<any> {
    const res = await http.post(
      "api/services/app/TemplateNotify/CreateOrUpdateNotificationTemplate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async GetParameters(params): Promise<any> {
    const res = await http.get(
      "api/services/app/TemplateNotify/GetParametersV2",
      {
        params,
      }
    )
    const { result } = res.data
    return result
  }

  public async getAllAccountingEntity(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/SystemConfiguration/GetAllAccountingEntity", { params })
    return res.data.result
  }

  public async updateAccountingEntity(body: any): Promise<any> {
    const res = await http.put("api/services/app/SystemConfiguration/UpdateAccountingEntitySetting", body)
    notifySuccess(LNotification("SUCCESS"), LNotification("SAVING_SUCCESSFULLY"))
    return res.data.result
  }

  /*
  * @param projectId
  * @returns
  */
  public async getListTemplate(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/TemplateNotify/GetAllTemplateMapWithProject", { params })
    const { result } = res.data
    // If result is an array, wrap it in PagedResultDto structure
    if (Array.isArray(result)) {
      return {
        totalCount: result.length,
        items: result
      }
    }
    return result
  }

  /*
  * @param body
  * {
  *   "projectInput": 0,
  *   "projectOutput": 0,
  *   "lstNotificationCode": [ "string" ]
  * }
  * @returns
  */
  public async cloneTemplate(body: any): Promise<any> {
    const res = await http.post("api/services/app/TemplateNotify/CloneAllProjectTemplate", body)
    notifySuccess(LNotification("SUCCESS"), LNotification("CLONING_SUCCESSFULLY"))
    return res.data.result
  }

  public async getAllNumberingConfig(params: any): Promise<any> {
    const res = await http.get("api/services/app/NumberingConfig/GetAll", { params })
    return res.data.result
  }

  /*
  * @param body
  * {
  *   "id": 0, // nếu là update truyền vào
  *   "module": number, // module id
  *   "prefix": "string",
  *   "suffix": "string",
  *   "paddingZeroNumber": 6 //mặc định là 6, cho chọn từ 1-12
  * }
  * 
  */
  public async createOrUpdateNumberingConfig(body: any): Promise<any> {
    const res = await http.post("api/services/app/NumberingConfig/CreateOrUpdateNumberingConfig", body)
    notifySuccess(LNotification("SUCCESS"), LNotification("SAVING_SUCCESSFULLY"))
    return res.data.result
  }

  public async getListModule(): Promise<any> {
    const res = await http.get("api/services/app/NumberingConfig/GetListModule")
    return res.data.result
  }

  public async sendMailSmtp(body: any): Promise<any> {
    const res = await http.post("api/services/app/SystemConfiguration/SendMailSmtp", body)
    notifySuccess(LNotification("SUCCESS"), LNotification("SEND_SUCCESSFULLY"))
    return res.data.result
  }
}

export default new SystemConfigurationService()
